<template>
  <div v-loading="ETHvolumeLoading">
    <el-row>
      <el-col :span="24">
        <div
          id="ETHvolumeBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  
 </div>
</template>

<script>
import IndexJs from "../Fees/index"
export default {
    mixins:[IndexJs]
}
</script>

<style>

</style>